import type { LicenseModule } from './src/utils/license';

export interface Perspective {
  key: string;
  labelKey: string;
  /** Licensed module the whole perspective belongs to; hidden without a licence. */
  module?: LicenseModule;
}

// The scheduling perspective carries no module because it also holds the shift plan, which is
// master data; its scheduling pages carry the module one by one (routeConfig.ts).
export const perspectives : Perspective[] = [
  { key: 'administration', labelKey: 'routes.administration' },
  { key: 'scheduling', labelKey: 'routes.scheduling' },
  { key: 'planning', labelKey: 'routes.planning', module: 'PLANNING' },
];